/**
 * Wrapper for supporting native smooth scroll with a fallback for IE & Safari
 */
const supportsNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style;

function smoothScrollTo(options) {
    if (supportsNativeSmoothScroll) {
        window.scrollTo(options);
    } else {
        const left = options.left ? options.left : 0;
        const top = options.top ? options.top : 0;
        window.scrollTo(left, top);
    }
}

function smoothScrollToIdentifier(identifier) {
    const scrollDestination = document.querySelector(`[data-scroll-destination-identifier="${ identifier }"]`);
    if (scrollDestination) {
        smoothScrollTo({ top: scrollDestination.getBoundingClientRect().top + window.pageYOffset, behavior: 'smooth' });
    }
}

function smoothScrollToWithOffset(element, offset){
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;

    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
    });
}

export { smoothScrollTo, smoothScrollToIdentifier, smoothScrollToWithOffset };
